import cn from 'classnames';

import { CryptoFileIcon } from '@atoms/Icon/CryptoFileIcon';

type Props = {
  className: string;
};

export const CryptoFundingEmptyStateContainer = ({ className }: Props) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 text-lg font-medium text-content-strong',
        className
      )}
    >
      <CryptoFileIcon />
      <div>Select an account to enable crypto funding options.</div>
    </div>
  );
};
